export default __webpack_public_path__ + "c670d94bc063e9ea69dc9c4b827ad542.svg";